(() => {
  const SELECTORS = {
    modal: '[data-sale-event-modal]',
    title: '.sale-event-modal__title',
    text: '.sale-event-modal__text',
    continueButton: '[data-sale-event-continue]',
    closeButton: '[data-sale-event-close]',
    productCard: 'product-card[handle]'
  };

  const initSaleEventModal = (modal) => {
    if (!modal || modal.dataset.saleEventInitialized === 'true') {
      return;
    }

    const formId = modal.dataset.formId;
    const form = document.getElementById(formId);

    if (!form) {
      return;
    }

    modal.dataset.saleEventInitialized = 'true';

    const continueButton = modal.querySelector(SELECTORS.continueButton);
    const title = modal.querySelector(SELECTORS.title);
    const textElement = modal.querySelector(SELECTORS.text);
    const closeButtons = Array.from(modal.querySelectorAll(SELECTORS.closeButton));
    const productCards = Array.from(modal.querySelectorAll(SELECTORS.productCard));
    const defaultTargetCount = Number( modal.dataset.targetCount || 2);
    const titleTemplateSingular = modal.dataset.titleTemplateSingular || 'Buy [target] and get 1 free';
    const titleTemplatePlural = modal.dataset.titleTemplatePlural || titleTemplateSingular;
    const titleComplete = modal.dataset.titleComplete || 'You get free product';

    const counterElement = modal.querySelector('[data-counter]')
    const counterCurrentValueElement = modal.querySelector('[data-counter-current]')

    const textElementTemplateSingular = modal.dataset.textTemplateSingular || 'Buy [target] and get 1 free';
    const textElementTemplatePlural = modal.dataset.textTemplatePlural || textElementTemplateSingular;
    let remainingTargetCount = defaultTargetCount;
    let lastActiveElement = null;
    let isTitleListenerAttached = false;

    const formatProgressTitle = () => {
      const titleTemplate = remainingTargetCount === 1 ? titleTemplateSingular : titleTemplatePlural;

      if (titleTemplate.includes('[target]')) {
        return titleTemplate.replace('[target]', remainingTargetCount);
      }

      return titleTemplate;
    };

    const formatProgressText = () => {
      const textTemplate = remainingTargetCount === 1 ? textElementTemplateSingular : textElementTemplatePlural;

      textElement.innerHTML = textTemplate.replace('[target]', remainingTargetCount)
        .replace('{', '<span class="as-db-0042-highlight">')
        .replace('}', '</span>');
    };

    const updateTitle = () => {
      if (!title) {
        return;
      }

      title.textContent = remainingTargetCount <= 0
        ? titleComplete
        : formatProgressTitle();
    };

    const updateCounter = () => {
      const currentCount = defaultTargetCount + 1 - remainingTargetCount
      counterElement.style.setProperty('--as-db-0042-fill', String(currentCount / (defaultTargetCount + 1)));

      counterCurrentValueElement.textContent = currentCount;
    };

    const resetTargetCount = async () => {
      remainingTargetCount = (defaultTargetCount + 1) - await getTargetCount();
      updateTitle();
      formatProgressText();
      updateCounter();
    };

    const resetActiveProducts = () => {
      productCards.forEach((card) => card.classList.remove('product-card__active'));
    };

    const highlightAddedProducts = (items = []) => {
      const addedHandles = items
        .map((item) => item?.handle)
        .filter(Boolean);

      if (!addedHandles.length) {
        return;
      }

      productCards.forEach((card) => {
        if (addedHandles.includes(card.getAttribute('handle'))) {
          card.classList.add('product-card__active');
        }
      });
    };

    const openModal = async () => {
      lastActiveElement = document.activeElement;
      await resetTargetCount();
      if(remainingTargetCount % (defaultTargetCount + 1) === 0) {
        openCartDrawer();
        return;
      }
      resetActiveProducts();
      if (!isTitleListenerAttached) {
        document.addEventListener('variant:add', handleUpdateTitle);
        isTitleListenerAttached = true;
      }
      modal.classList.add('is-visible');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('overflow-hidden');
    };

    const closeModal = () => {
      if (isTitleListenerAttached) {
        document.removeEventListener('variant:add', handleUpdateTitle);
        isTitleListenerAttached = false;
      }
      modal.classList.remove('is-visible');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('overflow-hidden');

      if (lastActiveElement instanceof HTMLElement) {
        lastActiveElement.focus();
      }
    };

    const openCartDrawer = () => {
      const drawer = document.querySelector('cart-drawer');

      if (drawer && typeof drawer.show === 'function') {
        drawer.show();
      }
    };

    function handleUpdateTitle(event) {
      if (event.target === form) return;

      if (modal.classList.contains('is-visible')) {
        remainingTargetCount = Math.max(remainingTargetCount - 1, 0);
        updateTitle();
        formatProgressText();
        updateCounter();
        highlightAddedProducts(event.detail?.items || []);

        if (remainingTargetCount === 0) {
          closeModal();
          openCartDrawer();
        }
      }
    }

    async function getTargetCount () {
      const cartData = await (await fetch('/cart.json')).json()
      const productsId = modal.dataset.targetProducts.split(',').map(id => +id)

      return cartData.items.reduce((acc, item) => {
        const isDiscounted = productsId.includes(item.product_id)

        if(isDiscounted) return acc + item.quantity

        return acc
      }, 0) % 3
    }

    form.addEventListener('variant:add', (event) => {
      openModal();
    });

    modal.addEventListener('variant:add', (event) => {
      if (event.target !== form) {
        event.detail.blockCartDrawerOpening = true;
      }
    });

    if (continueButton) {
      continueButton.addEventListener('click', () => {
        closeModal();
        openCartDrawer();
      });
    }

    closeButtons.forEach((button) => {
      button.addEventListener('click', () => {
        closeModal();
        openCartDrawer();
      });
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && modal.classList.contains('is-visible')) {
        closeModal();
        openCartDrawer();
      }
    });
  };

  const initAllSaleEventModals = () => {
    document.querySelectorAll(SELECTORS.modal).forEach(initSaleEventModal);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSaleEventModals);
  } else {
    initAllSaleEventModals();
  }
})();
